import React, { useState } from "react";
import {
  Box,
  Input,
  Button,
  InputGroup,
  InputLeftElement,
  Icon,
  useColorModeValue,
  FormLabel,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Text,
  Flex,
} from "@chakra-ui/react";
import { FaMapMarkerAlt, FaFilter, FaSearch } from "react-icons/fa";
import axios from "axios";

const SearchJob = () => {
  const boxShadow = useColorModeValue("lg", "dark-lg");
  const [isOpen, setIsOpen] = useState(false);
  const [distance, setDistance] = useState(50); // Default distance
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [pinCode, setPincode] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [search, setSearch] = useState('');
  const [filterDetails, setFilterDetails] = useState({
    search: '',
    latitude: '',
    longitude: '',
    pinCode: '',
    from: '',
    to: '',
    distance: ''
  });

  const locationButton = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      setFilterDetails((prevDetails) => ({
        ...prevDetails,
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      }));
      console.log(filterDetails);
    });
  };

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
    if (new Date(e.target.value) > new Date(toDate)) {
      setToDate(e.target.value);
    }
  };

  const handleToDateChange = (e) => {
    if (new Date(e.target.value) >= new Date(fromDate)) {
      setToDate(e.target.value);
    }
  };

  const filterApply = async (event) => {
    event.preventDefault();
    const updatedFilterDetails = {
      ...filterDetails,
      from: fromDate,
      to: toDate,
      distance: distance,
      search: search,
      pinCode: pinCode
    };

    console.log("Applying filters with details:", updatedFilterDetails);
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/applicant/get-filtered-job-suggestions`,
        updatedFilterDetails,
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );
      console.log('Response data: filter ? ', response.data); // Log the response data
      if (response.data.success) {
        
  
        //setIsEditable(false);
      } else {
        
      }
  
      // Optionally update the profile data after submission
      setFilterDetails({
        ...filterDetails, // Keep existing data
        // You can update any specific fields if needed
      });
    } catch (error) {
      console.error('Error submitting filter data:', error); // Updated error message
      
    }
      
  
};

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <Box borderRadius="lg" boxShadow={boxShadow} width="100%" p={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <InputGroup width="90%">
          <InputLeftElement pointerEvents="none">
            <Icon as={FaSearch} color="gray.300" />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Search jobs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            focusBorderColor="transparent"
            variant="filled"
            _focus={{ boxShadow: "none", outline: "none" }}
            size="md"
          />
        </InputGroup>
        <Popover
          isOpen={isOpen}
          onClose={handleClose}
          placement="bottom-end"
          closeOnBlur={false}
        >
          <PopoverTrigger>
            <Button
              colorScheme="blue"
              size="md"
              boxShadow="md"
              bg="blue.500"
              _hover={{ bg: "blue.600" }}
              _active={{ bg: "blue.700" }}
              color="white"
              leftIcon={<Icon as={FaFilter} />}
              onClick={handleOpen}
            >
              Filter
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader>Filter Options</PopoverHeader>
            <PopoverBody>
              <Flex direction="column" gap={2}>
                <Box>
                  <FormLabel mb={0}>Find by: Pincode</FormLabel>
                  <InputGroup>
                    <Input
                      type="text"
                      placeholder="Pincode"
                      value={pinCode}
                      onChange={(e) => setPincode(e.target.value)}
                      focusBorderColor="transparent"
                      variant="filled"
                      _focus={{ boxShadow: "none", outline: "none" }}
                      size="md"
                    />
                    <Button
                      colorScheme="blue"
                      size="md"
                      boxShadow="md"
                      bg="blue.500"
                      _hover={{ bg: "blue.600" }}
                      _active={{ bg: "blue.700" }}
                      color="white"
                      leftIcon={<Icon position="center" as={FaMapMarkerAlt} />}
                      onClick={locationButton}
                    />
                  </InputGroup>
                </Box>
                <Box>
                  <FormLabel mb={0}>From</FormLabel>
                  <Input
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    focusBorderColor="transparent"
                    variant="filled"
                    _focus={{ boxShadow: "none", outline: "none" }}
                    size="md"
                  />
                </Box>
                <Box>
                  <FormLabel mb={0}>To</FormLabel>
                  <Input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    min={fromDate} // Ensure "To" date is not before "From" date
                    focusBorderColor="transparent"
                    variant="filled"
                    _focus={{ boxShadow: "none", outline: "none" }}
                    size="md"
                  />
                </Box>
                <Box>
                  <FormLabel mb={0}>Distance</FormLabel>
                  <Slider
                    defaultValue={50}
                    min={20}
                    max={300}
                    step={10}
                    value={distance}
                    onChange={(val) => setDistance(val)}
                  >
                    <SliderTrack>
                      <SliderFilledTrack />
                    </SliderTrack>
                    <SliderThumb boxSize={5}>
                      <Box color="blue.500" as={FaMapMarkerAlt} />
                    </SliderThumb>
                  </Slider>
                  <Text mt={2} fontSize="sm" textAlign="center">
                    {distance} km
                  </Text>
                </Box>
                <Button
                  colorScheme="blue"
                  size="md"
                  boxShadow="md"
                  bg="blue.500"
                  _hover={{ bg: "blue.600" }}
                  _active={{ bg: "blue.700" }}
                  color="white"
                  width="100%"
                  onClick={filterApply} // Call filterApply on click
                >
                  Apply
                </Button>
              </Flex>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Flex>
    </Box>
  );
};

export default SearchJob;